import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface JobExtensionCompletedProgressionActionsProps {
  isExtensionRejected: boolean
  submittedExtensionConfirmationRejection: boolean
  isAnyExtensionFlowAvailable: boolean
  canCompleteJob?: boolean
  onUploadRejectionConfirmation: () => unknown
  onCompleteJob: () => unknown
  extensionActions?: ReactNode
}

export function JobExtensionCompletedProgressionActions({
  isExtensionRejected,
  submittedExtensionConfirmationRejection,
  isAnyExtensionFlowAvailable,
  canCompleteJob,
  onUploadRejectionConfirmation,
  onCompleteJob,
  extensionActions,
}: JobExtensionCompletedProgressionActionsProps) {
  return (
    <>
      {isExtensionRejected && !submittedExtensionConfirmationRejection && (
        <CardContent compactBottomPadding>
          <Button
            label="Upload Rejection Confirmation"
            variant="secondary"
            size="wide-slim"
            onPress={onUploadRejectionConfirmation}
            testId="job-progression-upload-rejection-confirmation-button"
          />
        </CardContent>
      )}

      {!isAnyExtensionFlowAvailable && (
        <CardContent>
          <Button
            label="Complete Job"
            variant="primary"
            size="wide-slim"
            onPress={onCompleteJob}
            testId="job-progression-complete-job-button"
            isDisabled={
              isExtensionRejected
                ? !(canCompleteJob && submittedExtensionConfirmationRejection)
                : !canCompleteJob
            }
          />
        </CardContent>
      )}

      {extensionActions}
    </>
  )
}
